<template>
  <div class="container platform-basic-info-page">
    <div class="title">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>平台建设</el-breadcrumb-item>
        <el-breadcrumb-item>基础信息</el-breadcrumb-item>
        <el-breadcrumb-item>SLA信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="title-en">1.服务器故障类工单SLA</div>
    <el-card class="box-card">
      <el-table
        :data="serverFaultData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="class" align="center">
          <template slot="header">
            <div>工单级别</div>
            <div>ServerFaultClass</div>
          </template>
        </el-table-column>
        <el-table-column prop="responseTime" align="center">
          <template slot="header">
            <div>工单响应与分派(分钟)</div>
            <div>ServerFailRD_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="arrivalTime" align="center">
          <template slot="header">
            <div>服务人员达到现场</div>
            <div>ServerFailEA_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="completionTime" align="center">
          <template slot="header">
            <div>操作完成时间</div>
            <div>ServerFaultOF_SLA</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="title-en">2.服务器资源交付类丅单SLA</div>
    <el-card class="box-card">
      <el-table
        :data="serverResourceData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="class" align="center">
          <template slot="header">
            <div>工单类型</div>
            <div>ServerResClass</div>
          </template>
        </el-table-column>
        <el-table-column prop="responseTime" align="center">
          <template slot="header">
            <div>工单响应与分派(分钟)</div>
            <div>ServerResRD_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="arrivalTime" align="center">
          <template slot="header">
            <div>服务人员达到现场</div>
            <div>ServerResEA_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="completionTime" align="center">
          <template slot="header">
            <div>操作完成时间</div>
            <div>ServerResOF_SLA</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <div class="title-en">3.网络故障类工单SLA</div>
    <el-card class="box-card">
      <el-table
        :data="netFaultData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="class" align="center">
          <template slot="header">
            <div>工单级别</div>
            <div>NetFaultClass</div>
          </template>
        </el-table-column>
        <el-table-column prop="responseTime" align="center">
          <template slot="header">
            <div>工单响应与分派(分钟)</div>
            <div>NetFaultRD_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="arrivalTime" align="center">
          <template slot="header">
            <div>服务人员达到现场</div>
            <div>NetFaultEA_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="completionTime" align="center">
          <template slot="header">
            <div>操作完成时间</div>
            <div>NetFaultOP_SLA</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="title-en">4.网络其它工单SLA</div>
    <el-card class="box-card">
      <el-table
        :data="netOthersData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="class" align="center">
          <template slot="header">
            <div>工单类型</div>
            <div>NetOthersClass2</div>
          </template>
        </el-table-column>
        <el-table-column prop="responseTime" align="center">
          <template slot="header">
            <div>工单响应与分派</div>
            <div>NetOters2RD_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="arrivalTime" align="center">
          <template slot="header">
            <div>服务人员达到现场</div>
            <div>NetOters2EA_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="completionTime" align="center">
          <template slot="header">
            <div>操作完成时间</div>
            <div>NetOters2OF_SLA</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="title-en">5.资产操作类工单SLA</div>
    <el-card class="box-card">
      <el-table
        :data="assetOperationData"
        style="width: 100%"
        :header-cell-style="headerStyle"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="class" align="center">
          <template slot="header">
            <div>资产操作类</div>
            <div>AssetStoreClass</div>
          </template>
        </el-table-column>
        <el-table-column prop="responseTime" align="center">
          <template slot="header">
            <div>工单响应与分派(分钟)</div>
            <div>AssetStoreRD_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="arrivalTime" align="center">
          <template slot="header">
            <div>服务人员达到现场</div>
            <div>AssetStoreEA_SLA</div>
          </template>
        </el-table-column>
        <el-table-column prop="completionTime" align="center">
          <template slot="header">
            <div>操作完成时间</div>
            <div>AssetStoreOF_SLA</div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerStyle: {
        background: '#F5F7FA',
        color: '#303133',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      serverFaultData: [
        {
          class: '一级\nServerFault_1st',
          responseTime: '30',
          arrivalTime: '2.5小时',
          completionTime: '4小时',
        },
        {
          class: '二级\nServerFault_2rd',
          responseTime: '60',
          arrivalTime: '第二自然日',
          completionTime: '8小时',
        },
        {
          class: '三级\nServerFault_3rd',
          responseTime: '120',
          arrivalTime: '第二自然日',
          completionTime: '24小时',
        },
      ],
      serverResourceData: [
        {
          class: '直配\nServerRes_DCon',
          responseTime: '120',
          arrivalTime: '第二自然日',
          completionTime: '第二自然日',
        },
        {
          class: '搬迁\nServerRes_Relocate',
          responseTime: '120',
          arrivalTime: '第二自然日',
          completionTime: '第二自然日',
        },
        {
          class: 'TPC\nServerRes_TPC',
          responseTime: '120',
          arrivalTime: '第二自然日',
          completionTime: '第二自然日',
        },
        {
          class: '退役\nServerRes_Retire',
          responseTime: '120',
          arrivalTime: '第二自然日',
          completionTime: '3自然日',
        },
      ],
      assetOperationData: [
        {
          class: '出库\nAssetStore_In',
          responseTime: '60',
          arrivalTime: '下单后最晚\n第二个工作日14:00前',
          completionTime: '下单后\n第二个工作日18:00前完成',
        },
        {
          class: '入库\nAssetStore_out',
          responseTime: '60',
          arrivalTime: '服务人员达到现场',
          completionTime: '操作完成时间',
        },
      ],
      netFaultData: [
        {
          class: '重要\nNetFault_Important',
          responseTime: '5',
          arrivalTime:
            '7*24驻场机房:\n15分钟\n非7*24驻场机房:\n15分钟（工作时间）\n60分钟（非工作时间）',
          completionTime: '5分钟',
        },
        {
          class: '一级\nNetFault_1st',
          responseTime: '10',
          arrivalTime:
            '7*24驻场机房:\n15分钟\n非7*24驻场机房:\n15分钟（工作时间）\n60分钟（非工作时间）',
          completionTime: '120分钟',
        },
        {
          class: '二级\nNetFault_2rd',
          responseTime: '30',
          arrivalTime: '12小时',
          completionTime: '4小时',
        },
        {
          class: '三级\nNetFault_3rd',
          responseTime: '120',
          arrivalTime: '24小时',
          completionTime: '24小时',
        },
      ],
      netOthersData: [
        {
          class: '机架裁撤\nNetOters1_RackDissolve',
          responseTime: '24小时',
          arrivalTime: '第二自然日',
          completionTime: '7自然日',
        },
        {
          class: '零星链路布线与裁撤\nNetOthers1_LinkCable',
          responseTime: '24小时',
          arrivalTime: '第二自然日',
          completionTime: '2自然日',
        },
        {
          class: '部件拆分\nNetOthers2_Split',
          responseTime: '24小时',
          arrivalTime: '第二自然日',
          completionTime: '7自然日',
        },
        {
          class: '现场支持\nNetOters2_SiteSupport',
          responseTime: '60分钟',
          arrivalTime: '/',
          completionTime: '/',
        },
        {
          class: '设备下架\nNetOters2_Eremove',
          responseTime: '120分钟',
          arrivalTime: '第二自然日',
          completionTime: '12小时',
        },
        {
          class: '清理配置\nNetOters2_Clear',
          responseTime: '120分钟',
          arrivalTime: '第二自然日',
          completionTime: '48小时',
        },
        {
          class: '链路调试\nNetOters2_LinkDebug',
          responseTime: '120分钟',
          arrivalTime: '第二自然日',
          completionTime: '2自然日',
        },
        {
          class: '端口及模块操作\nNetOters2_PortModule',
          responseTime: '120分钟',
          arrivalTime: '第二自然日',
          completionTime: '2自然日',
        },
        {
          class: 'ODF链路操作\nNetOters2_ODFLink',
          responseTime: '120分钟',
          arrivalTime: '第二自然日',
          completionTime: 'ODF链路检查：3自然日\nODF端口操作：2自然日\nODF链路截撤：1自然日',
        },
        {
          class: '工程复检\nNetOters2_ProjectCheck',
          responseTime: '120分钟',
          arrivalTime: '12小时',
          completionTime: '2自然日',
        },
        {
          class: 'IDC现场监管\nNetOters2_IDCMonitor',
          responseTime: '120分钟',
          arrivalTime: '第二自然日',
          completionTime: '1自然日',
        },
        {
          class: 'IDC机房巡检\nNetOters2_IDCInspector',
          responseTime: '120分钟',
          arrivalTime: '第二自然日',
          completionTime: '1自然日',
        },
      ],
      netOthers1Data: [
        {
          class: '机架裁撤\nNetOters1_RackDissolve',
          responseTime: '24小时',
          arrivalTime: '第二自然日',
          completionTime: '7自然日',
        },
        {
          class: '零星链路布线与裁撤\nNetOthers1_LinkCable',
          responseTime: '24小时',
          arrivalTime: '第二自然日',
          completionTime: '2自然日',
        },
        {
          class: '部件拆分\nNetOthers2_Split',
          responseTime: '24小时',
          arrivalTime: '第二自然日',
          completionTime: '7自然日',
        },
      ],
    };
  },
  methods: {
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}
.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}
.box-card {
  margin-bottom: 20px;
}

::v-deep .el-table {
  th.el-table__cell {
    background-color: #4e71be !important;
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
      color: #fff;
    }
  }
  th.el-table__cell:first-child {
    border: 0.5px solid #fff;
  }
  .el-table__header {
    border-color: #fff;
  }
  td.el-table__cell {
    border: 0.5px solid #fff;
    .cell {
      white-space: pre-line;
      line-height: 1.5;
    }
  }
  td.el-table__cell:first-child {
    background-color: #4e71be !important;
    color: #fff;
  }
  tr:hover > td.el-table__cell:first-child {
    background-color: #4e71be !important;
  }
}

::v-deep .el-table .even-row {
  background-color: #ced4e8;
}

::v-deep .el-table .odd-row {
  background-color: #e9ebf3;
}
</style>